var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"appearance":"spaced"}},[_vm._t("prepend",null,{"cols":"12"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }